import React from 'react';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { Location } from '../../../../components';
import type { TaxonomyLocation } from '../../../../types/uncinc_profile/taxonomy';

interface LocationProjectProps {
  entity: ImmutableEntity<TaxonomyLocation>;
}

const TaxonomyLocationProject: React.FC<LocationProjectProps> = ({ entity }) => {
  const term = entity.toJS();
  const name = term.name[0].value;
  const address = term.field_address[0];
  const wheelchairAccessible = term.field_wheelchair_accessible[0]?.value;

  if (!address) {
    return null;
  }

  return (
    <Location
      className="TaxonomyLocationProject"
      name={name}
      addressLine={address.address_line1}
      postalCode={address.postal_code}
      city={address.locality}
      countryCode={address.country_code}
      wheelchairAccessible={wheelchairAccessible}
    />
  );
};

export default TaxonomyLocationProject;
